import i18n from '../../language/index'
import store from '@/vuex/store.js'
export function basic_button_create_style_obj(){
  return [
    //文字颜色定死白色
    {
      id: '0',
      name: i18n.t('widgets_basic_button_patternstyle_454'),
      data: {
        styleType: 'type_0',
        borderRadius: {
          radio_val: 'default',
          default: {
            value: 4,
          },
        },
        border: {
          radio_val: 'default',
          default: {
            borderWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderStyle: 'solid',
            borderColor: "rgba(255, 255, 255,1)",
            borderSeColor: "rgba(0, 0, 0,1)",
            checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
          },
        },
        background: {
          radio_val: 'default',
          default: {
            color: store.state.myRender.common.theme_color, // 背景设置-颜色
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            seColor: store.state.myRender.common.theme_color, // 背景设置-选中颜色
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        },
        font: {
          radio_val: 'default',
          default: {
            fontStyle: '',
            fsItalics: 'normal',
            fontUnderline: 'none',
            fontSize: 16,
            fontWidth: 'normal',
            fontColor: 'rgba(255,255,255,1)',
            fontSeColor: 'rgba(255,255,255,1)',
            fontFamily: 'Arial',
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        }
      }
    },

    //文字颜色定死白色
    {
      id: '1',
      name: i18n.t('widgets_basic_button_patternstyle_455'),
      data: {
        styleType: 'type_1',
        borderRadius: {
          radio_val: 'default',
          default: {
            value: 50,
          },
        },
        border: {
          radio_val: 'default',
          default: {
            borderWidth: 1,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderStyle: 'solid',
            borderColor: store.state.myRender.common.theme_color,
            borderSeColor: store.state.myRender.common.theme_color,
            checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
          },
        },
        background: {
          radio_val: 'default',
          default: {
            color: store.state.myRender.common.theme_color, // 背景设置-颜色
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            seColor: 'rgba(255,255,255,1)', // 背景设置-选中颜色
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        },
        font: {
          radio_val: 'default',
          default: {
            fontStyle: '',
            fsItalics: 'normal',
            fontUnderline: 'none',
            fontSize: 16,
            fontWidth: 'normal',
            fontColor: 'rgba(255,255,255,1)',
            fontSeColor: store.state.myRender.common.theme_color,
            fontFamily: 'Arial',
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        }
      }
    },

    //文字颜色定死白色
    {
      id: '2',
      name: i18n.t('widgets_basic_button_patternstyle_456'),
      data: {
        styleType: 'type_2',
        borderRadius: {
          radio_val: 'default',
          default: {
            value: 4,
          },
        },
        border: {
          radio_val: 'default',
          default: {
            borderWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderStyle: 'solid',
            borderColor: "rgba(255, 255, 255,1)",
            borderSeColor: "rgba(0, 0, 0,1)",
            checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
          },
        },
        background: {
          radio_val: 'default',
          default: {
            color: store.state.myRender.common.theme_color, // 背景设置-颜色
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            seColor: store.state.myRender.common.theme_color, // 背景设置-选中颜色
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        },
        font: {
          radio_val: 'default',
          default: {
            fontStyle: '',
            fsItalics: 'normal',
            fontUnderline: 'none',
            fontSize: 16,
            fontWidth: 'normal',
            fontColor: 'rgba(255,255,255,1)',
            fontSeColor: 'rgba(255,255,255,1)',
            fontFamily: 'Arial',
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        }
      }
    },

    //文字颜色定死#333
    //背景定死
    {
      id: '3',
      name: i18n.t('widgets_basic_button_patternstyle_457'),
      data: {
        styleType: 'type_3',
        borderRadius: {
          radio_val: 'default',
          default: {
            value: 50,
          },
        },
        border: {
          radio_val: 'default',
          default: {
            borderWidth: 1,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderStyle: 'solid',
            borderColor: "rgba(204, 204, 204,1)",
            borderSeColor: store.state.myRender.common.theme_color,
            checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
          },
        },
        background: {
          radio_val: 'default',
          default: {
            color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        },
        font: {
          radio_val: 'default',
          default: {
            fontStyle: '',
            fsItalics: 'normal',
            fontUnderline: 'none',
            fontSize: 16,
            fontWidth: 'normal',
            fontColor: 'rgba(51,51,51,1)',
            fontSeColor: store.state.myRender.common.theme_color,
            fontFamily: 'Arial',
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        }
      }
    },
    {
      id: '4',
      name: i18n.t('widgets_basic_button_patternstyle_458'),
      data: {
        styleType: 'type_4',
        borderRadius: {
          radio_val: 'default',
          default: {
            value: 0,
          },
        },
        border: {
          radio_val: 'default',
          default: {
            borderWidth: 1,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderStyle: 'solid',
            borderColor: store.state.myRender.common.theme_color,
            borderSeColor: store.state.myRender.common.theme_color,
            checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
          },
        },
        background: {
          radio_val: 'default',
          default: {
            color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            seColor: store.state.myRender.common.theme_color, // 背景设置-选中颜色
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        },
        font: {
          radio_val: 'default',
          default: {
            fontStyle: '',
            fsItalics: 'normal',
            fontUnderline: 'none',
            fontSize: 16,
            fontWidth: 'normal',
            fontColor: store.state.myRender.common.theme_color,
            fontSeColor: 'rgba(255,255,255,1)',
            fontFamily: 'Arial',
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        }
      }
    },
    {
      id: '5',
      name: i18n.t('widgets_basic_button_patternstyle_459'),
      data: {
        styleType: 'type_5',
        borderRadius: {
          radio_val: 'default',
          default: {
            value: 0,
          },
        },
        border: {
          radio_val: 'default',
          default: {
            borderWidth: 1,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderStyle: 'solid',
            borderColor: store.state.myRender.common.theme_color,
            borderSeColor: store.state.myRender.common.theme_color,
            checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
          },
        },
        background: {
          radio_val: 'default',
          default: {
            color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            seColor: store.state.myRender.common.theme_color, // 背景设置-选中颜色
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        },
        font: {
          radio_val: 'default',
          default: {
            fontStyle: '',
            fsItalics: 'normal',
            fontUnderline: 'none',
            fontSize: 16,
            fontWidth: 'normal',
            fontColor: store.state.myRender.common.theme_color,
            fontSeColor: 'rgba(255,255,255,1)',
            fontFamily: 'Arial',
            pattern: 'pure_color',
            linear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
            sePattern: 'pure_color',
            seLinear_gradient: {
              start_color: "rgba(156,40,177,1)",
              end_color: "rgba(0, 0, 0,1)",
              start_pointer: 12,
              end_pointer: 100,
              deg: 90
            },
          },
        }
      }
    }
    ]
  }



// WEBPACK FOOTER //
// ./src/widgets/basic_button/patternStyle.js